import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private quantidade = 0;
  private readonly mostrarSubject = new BehaviorSubject<boolean>(false);

  readonly mostrar$ = this.mostrarSubject.asObservable();

  get mostrar(): boolean {
    return this.mostrarSubject.value;
  }

  adicionar(): void {
    this.quantidade++;
    this.mostrarSubject.next(true);
  }

  remover(): void {
    this.quantidade--;

    if (this.quantidade < 0) {
      this.quantidade = 0;
    }

    if (this.quantidade === 0) {
      this.mostrarSubject.next(false);
    }
  }
}
